import { getAxiosClient } from "src/utils/axios";

export const authProfile = (data) => ({
  type: "AUTH",
  data,
});

export const getVerify = (userId) => async () => {
  const cli = getAxiosClient("authVerify");
  try {
    const res = await cli.get(`/${userId}/verify`);
    return res.data;
  } catch (e) {
    console.log(e);
  }
};
